"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.home = exports.Home = exports.StorageParams = exports.StorageKeys = void 0;
const app_1 = require("app");
const app_2 = require("app");
const dictionary_1 = require("./dictionary");
exports.StorageKeys = {
    shouldRedirect: 'shouldredirect',
    redirectTo: 'redirectto',
};
exports.StorageParams = {
    YES: 'YES',
    UNSELECTED: 'UNSELECTED',
};
class Home extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.home-page';
        this.globalSitePath = ['/en/', '/en'];
        this.currentPathname = window.location.pathname;
        this.renderModalDialog = (dictionary, linkToRedirect) => {
            const classes = 'redirect-dialog';
            this.headerIconGlobal = $('#header-icon-global').get(0);
            // const component = (
            // <RedirectDialog
            //   message={dictionary.redirectMessage}
            //   acceptButtonLabel={dictionary.goToUSLabel}
            //   declineButtonLabel={dictionary.stayOnGlobalLabel}
            //   linkToRedirect={linkToRedirect}
            //   setStorage={this.setRedirectDataToStorage}
            // />
            // );
            // const additionalModalParameters: ModalAdditionalParametersType = {
            //   classes,
            //   backdrop: "static",
            //   keyboard: false,
            // };
            // RenderModal(component, this.headerIconGlobal, null, additionalModalParameters);
        };
        this.processRedirect = (dictionary, redirectUrlEndpoint) => {
            if (this.globalSitePath.indexOf(this.currentPathname) > -1) {
                const { shouldRedirect, redirectTo } = this.getRedirectDataFromStorage();
                switch (true) {
                    case !!redirectTo &&
                        redirectTo !== this.currentPathname &&
                        shouldRedirect === exports.StorageParams.YES &&
                        this.isPathValid(redirectTo):
                        // Redirect if selected
                        document.documentElement.style.opacity = '0';
                        window.location.pathname = redirectTo;
                        break;
                    case shouldRedirect === exports.StorageParams.UNSELECTED && !!redirectTo:
                        // Render modal if not selected
                        this.renderModalDialog(dictionary, redirectTo);
                        break;
                    case !!redirectUrlEndpoint && !shouldRedirect:
                        // Check should redirect
                        (0, app_1.api)(redirectUrlEndpoint, {})
                            .then(({ data: redirectUrl }) => {
                            // Don't render modal if response empty
                            if (redirectUrl) {
                                this.isNeedRedirect(redirectUrl, dictionary);
                            }
                        })
                            .catch(error => console.error('error', error));
                        break;
                    default:
                        // Clear storage if redirect not valid
                        if (shouldRedirect === exports.StorageParams.YES &&
                            !!redirectTo &&
                            !this.isPathValid(redirectTo)) {
                            this.clearStorage();
                        }
                }
            }
        };
        this.getRedirectDataFromStorage = () => {
            const redirectTo = app_2.SessionService.getDataFromStorage(exports.StorageKeys.redirectTo);
            const shouldRedirect = app_2.SessionService.getDataFromStorage(exports.StorageKeys.shouldRedirect);
            return { shouldRedirect, redirectTo };
        };
        this.setRedirectDataToStorage = (url, redirectAction) => {
            app_2.SessionService.setDataToStorage(exports.StorageKeys.shouldRedirect, redirectAction);
            app_2.SessionService.setDataToStorage(exports.StorageKeys.redirectTo, url);
        };
        this.clearStorage = () => {
            app_2.SessionService.removeDataFromStorage(exports.StorageKeys.shouldRedirect);
            app_2.SessionService.removeDataFromStorage(exports.StorageKeys.redirectTo);
        };
        this.isPathValid = (redirectTo) => {
            return app_1.UrlService.isValidUrl(`${window.location.origin}${redirectTo}`);
        };
    }
    OnInit() {
        const dictionary = (0, app_1.transformDictionary)(dictionary_1.redirectDictionary, app_1.AttrService.data(this.el[0], 'dictionary'));
        const redirectUrl = app_1.AttrService.data(this.el[0], 'redirect-url-endpoint');
        //this.processRedirect(dictionary, redirectUrl);
    }
    isNeedRedirect(redirectUrl, dictionary) {
        this.setRedirectDataToStorage(redirectUrl, 'UNSELECTED');
        this.renderModalDialog(dictionary, redirectUrl);
    }
}
exports.Home = Home;
exports.home = new Home();
